import React from 'react';
import * as MyCells from '../../../../utils/Cells';
import * as enums from '../../../../utils/EnumMapping';
import ActionMenu from '../../../common/action/ActionMenu';
import { ListCell } from '../../../common/cells/ListCell';
import StatusCell from '../../../common/cells/StatusCell';
import { MultiSelectFilterFn } from '../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../common/filters/MultiSelectColumnFilter';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../common/filters/TextColumnFilter';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../common/filters/DateRangeColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'employee.state',
            id: 'employee.state',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Típus',
            accessor: 'typeLabel',
            id: 'typeLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Munkavállaló',
            accessor: 'employee.name',
            id: 'employee.name',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Fizetési mód',
            accessor: 'paymentMethodLabel',
            id: 'paymentMethodLabel',
            show: true,
            className: 'iconColumn',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
            Cell: props => <MyCells.IconCell label={props.value} list={enums.paymentMethods} />,
        },
        {
            Header: 'Jelenlegi Bankszámlaszám',
            accessor: 'currentBankAccountNumbers',
            id: 'currentBankAccountNumbers',
            show: true,
            Cell: props => <ListCell cell={props} delimiter=', ' />,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Bruttó fizetés',
            accessor: 'employee.currentGrossSalary',
            id: 'employee.currentGrossSalary',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Nettó fizetés',
            accessor: 'employee.currentNetSalary',
            id: 'employee.currentNetSalary',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Össz szabadság',
            accessor: 'availableVacationDays',
            id: 'availableVacationDays',
            show: true,
            className: 'iconColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Felhasználható szabadság',
            accessor: 'remainingVacationDays',
            id: 'remainingVacationDays',
            show: true,
            className: 'iconColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Betegszabadság',
            accessor: 'sickDays',
            id: 'sickDays',
            show: true,
            className: 'iconColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Táppénz',
            accessor: 'govPaidSickDays',
            id: 'govPaidSickDays',
            show: true,
            className: 'iconColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Jogviszony kezdete',
            accessor: 'startDate',
            id: 'startDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Jogviszony vége',
            accessor: 'endDate',
            id: 'endDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Jogosítvány',
            accessor: 'driverLicenseLabel',
            id: 'driverLicenseLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'employee'} refresh={refresh} />,
        },
    ]
}